import { useInfiniteQuery } from '@tanstack/react-query';
import { container } from '@src/container';
import { GetPublicPascosUseCase } from '@src/application/pascos/usecases';

export interface GetPublicPascosParams {
    universityId?: string;
    courseCode?: string;
    semester?: string;
    academicYear?: string;
    skip?: number;
    limit?: number;
}

export const useGetPublicPascos = (params: GetPublicPascosParams = {}) => {
    const getPublicPascosUseCase = container.resolve<GetPublicPascosUseCase>('GetPublicPascosUseCase');

    return useInfiniteQuery({
        queryKey: ['pascos', 'public', params],
        queryFn: async ({ pageParam = 0 }) => {
            const skip = pageParam * (params.limit || 20);
            return getPublicPascosUseCase.execute(
                params.universityId,
                skip,
                params.limit || 20,
                {
                    courseCode: params.courseCode,
                    semester: params.semester,
                    academicYear: params.academicYear,
                }
            );
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.hasMore ? allPages.length : undefined;
        },
        initialPageParam: 0,
    });
};